<template>
  <v-tooltip
    top
    max-width="200"
  >
    <template v-slot:activator="{ on }">
      <SubscriptionNotificationDialog v-model="showNotification" :loading="state.loading"/>
      <tk-btn
        color="primary"
        v-if="!black"
        flat
        tag="a"
        class="clear-btn text-none caption"
        :loading="state.loading"
        @click="subscribe"
        v-on="on"
        :disabled="isSubscribed"
      >
        <span class="text-none caption">{{$t('Follow artist')}}</span>
      </tk-btn>

      <tk-btn
        v-else
        block
        large
        color="primary"
        class="black-btn mb-4"

        :loading="state.loading"
        @click="subscribe"
        v-on="isLoggedIn ? null : on"
        :disabled="isSubscribed"
      >
        <v-icon size="17" left color="white">far fa-bell</v-icon>
        <span class="text-none caption">{{$t('Follow artist')}}</span>
      </tk-btn>
    </template>
    <span>{{ $t("ArtworkSubscribeForm.hint") }}</span>
  </v-tooltip>
</template>

<script>
import { useFormAction } from '../../../../utils/Promis'
import { theArtistRepository } from '../../../../services/artist/ArtistRepository'
import { Artist } from '../../../../services/artist/Artist'
import SubscriptionNotificationDialog from '../../Subscribtion/SubscriptionNotificationDialog'

export default {
  name: 'ArtworkSubscribeForm',
  components: { SubscriptionNotificationDialog },
  props: {
    artist: {
      type: Artist,
      required: true,
    },
    black: Boolean
  },
  data () {
    return {
      showNotification: false,
      state: {
        loading: false,
        data: null
      }
    }
  },

  computed: {
    isLoggedIn () {
      return !!(this.$auth && this.$auth.currentUser);
    },
    isSubscribed() {
      return !!this.artist.my_subscription_id;
    },
  },

  methods: {
    subscribe () {
      if (!this.isLoggedIn) {
        this.$app.loginTitle = this.$t("ArtworkSubscribeForm.hint")
        this.$app.loginDialog = true;
        return;
      }

      this.state = useFormAction(async () => {
        const user = this.$auth.currentUser
        if (!(user && user.id && this.artist.id)) return
        const subscription = await theArtistRepository.subscribe(user, this.artist)
        this.showNotification = true
        this.$emit('update:subscription', subscription)
        return subscription
      })
    }
  },
}
</script>

<style scoped>
.black-btn{
  padding-top: 15px;
  padding-bottom: 15px;
  height: 60px;
}
</style>
